import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MessageComponent } from '@components/shared/message/index.component';
import { MainNavLayoutComponent } from '@components/layouts/main-nav/index.component';
import { PaginateBarComponent } from '@components/shared/paginatebar/index.component';
import { SimpleModalComponent } from '@components/shared/modal/simple-modal.component';
import { SocketMessageComponent } from '@components/shared/app/socket-message/index.component';
import { PopupContentDirective } from '../directives/popup-content.directive';
import { ExpandableContentDirective } from '../directives/expandable-content.directive';
import { DigitOnlyDirective } from '../directives/digit-only.directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import DatePickerComponent from '@components/shared/date-picker/date-picker.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SafeUrlPipe } from '@components/shared/pipes/safe-url.pipe.ts';

@NgModule({
  declarations: [
    MainNavLayoutComponent,
    PaginateBarComponent,
    SimpleModalComponent,
    MessageComponent,
    DatePickerComponent,
    SocketMessageComponent,
    PopupContentDirective,
    ExpandableContentDirective,
    DigitOnlyDirective,
    SafeUrlPipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxChartsModule,
    NgxSliderModule,
    NgbModule,
    LazyLoadImageModule,
  ],
  exports: [
    MainNavLayoutComponent,
    PaginateBarComponent,
    SimpleModalComponent,
    MessageComponent,
    DatePickerComponent,
    SocketMessageComponent,
    PopupContentDirective,
    ExpandableContentDirective,
    DigitOnlyDirective,

    NgxChartsModule,
    NgxSliderModule,
    LazyLoadImageModule,
    SafeUrlPipe
  ],
  providers: [],
})
export class SharedModule { }
